// Genera l'immagine verticale 1080x1920 della Vetrina Livelli, pronta per le storie.
import { LEVEL_STYLES } from "@/components/CreatorLevelBadge";

const W = 1080;
const H = 1920;
const NF = new Intl.NumberFormat("it-IT", { useGrouping: "always" });

const loadImg = (src) =>
  new Promise((res, rej) => {
    const im = new Image();
    im.onload = () => res(im);
    im.onerror = rej;
    im.src = src;
  });

const spaced = (ctx, text, x, y, ls) => {
  let cx = x - (ctx.measureText(text).width + ls * (text.length - 1)) / 2;
  for (const ch of text) {
    ctx.fillText(ch, cx + ctx.measureText(ch).width / 2, y);
    cx += ctx.measureText(ch).width + ls;
  }
};

export async function buildLevelShareCard({ level, name, points, ladder }) {
  const cur = LEVEL_STYLES[level] || LEVEL_STYLES[1];
  const cv = document.createElement("canvas");
  cv.width = W;
  cv.height = H;
  const ctx = cv.getContext("2d");
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  // sfondo cinematografico
  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#0a0612");
  bg.addColorStop(0.5, "#070410");
  bg.addColorStop(1, "#0d0616");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  // aura del colore gemma dietro l'eroe
  const aura = ctx.createRadialGradient(W / 2, 720, 60, W / 2, 720, 620);
  aura.addColorStop(0, cur.ring + "59");
  aura.addColorStop(0.55, cur.ring + "1f");
  aura.addColorStop(1, "transparent");
  ctx.fillStyle = aura;
  ctx.fillRect(0, 0, W, H);

  // raggi sottili rotanti
  ctx.save();
  ctx.translate(W / 2, 720);
  for (let i = 0; i < 14; i++) {
    ctx.rotate(Math.PI / 7);
    const ray = ctx.createLinearGradient(0, 0, 0, -560);
    ray.addColorStop(0, cur.ring + "26");
    ray.addColorStop(1, "transparent");
    ctx.fillStyle = ray;
    ctx.fillRect(-3, -560, 6, 560);
  }
  ctx.restore();

  // stelline
  for (let i = 0; i < 90; i++) {
    const a = Math.random() * 0.5 + 0.08;
    ctx.fillStyle = `rgba(255,255,255,${a})`;
    const r = Math.random() * 2.2 + 0.5;
    ctx.beginPath();
    ctx.arc(Math.random() * W, Math.random() * H, r, 0, Math.PI * 2);
    ctx.fill();
  }

  // header
  ctx.fillStyle = "#ffffff";
  ctx.font = "900 64px system-ui, -apple-system, sans-serif";
  spaced(ctx, "ADE", W / 2, 150, 18);
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "800 30px system-ui, -apple-system, sans-serif";
  spaced(ctx, "VETRINA LIVELLI", W / 2, 224, 14);

  // gemma
  const gem = await loadImg(cur.img);
  const gs = 720;
  ctx.save();
  ctx.shadowColor = cur.ring;
  ctx.shadowBlur = 110;
  ctx.drawImage(gem, W / 2 - gs / 2, 720 - gs / 2, gs, gs);
  ctx.restore();

  // nome livello
  ctx.fillStyle = "#ffffff";
  ctx.shadowColor = cur.ring;
  ctx.shadowBlur = 60;
  ctx.font = "900 108px system-ui, -apple-system, sans-serif";
  spaced(ctx, (name || cur.name).toUpperCase(), W / 2, 1220, 10);
  ctx.shadowBlur = 0;
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "800 32px system-ui, -apple-system, sans-serif";
  spaced(ctx, `LIVELLO ${level} DI ${ladder?.length || 6}`, W / 2, 1300, 12);

  // punti
  ctx.fillStyle = "#ffffff";
  ctx.shadowColor = cur.ring;
  ctx.shadowBlur = 44;
  ctx.font = "900 150px system-ui, -apple-system, sans-serif";
  ctx.fillText(NF.format(points || 0), W / 2, 1450);
  ctx.shadowBlur = 0;
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "800 32px system-ui, -apple-system, sans-serif";
  spaced(ctx, "PUNTI CREATOR", W / 2, 1545, 14);

  // scalata: mini gemme in fila
  const levels = Object.keys(LEVEL_STYLES).map(Number);
  const imgs = await Promise.all(levels.map((l) => loadImg(LEVEL_STYLES[l].img).catch(() => null)));
  const mini = 104;
  const gap = 52;
  const total = levels.length * mini + (levels.length - 1) * gap;
  let mx = W / 2 - total / 2;
  levels.forEach((l, i) => {
    const im = imgs[i];
    if (!im) return;
    ctx.save();
    if (l > level) {
      ctx.globalAlpha = 0.28;
      ctx.filter = "grayscale(0.9) brightness(0.6)";
    } else {
      ctx.shadowColor = LEVEL_STYLES[l].ring;
      ctx.shadowBlur = 26;
    }
    ctx.drawImage(im, mx, 1660, mini, mini);
    ctx.restore();
    mx += mini + gap;
  });

  ctx.fillStyle = "rgba(255,255,255,0.35)";
  ctx.font = "800 26px system-ui, -apple-system, sans-serif";
  spaced(ctx, "LA SCALATA CREATOR", W / 2, 1830, 12);

  const blob = await new Promise((res) => cv.toBlob(res, "image/png"));
  return new File([blob], `vetrina-${(name || cur.name).toLowerCase().replace(/\s+/g, "-")}.png`, { type: "image/png" });
}
